import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type DummyPrivatePageEndpointContextDataFragment = (
  { __typename: 'DummyPrivatePageEndpoint' }
  & Pick<SchemaTypes.DummyPrivatePageEndpoint, 'body'>
);

export const DummyPrivatePageEndpointContextDataFragmentDoc = /*#__PURE__*/ gql`
    fragment DummyPrivatePageEndpointContextData on DummyPrivatePageEndpoint {
  body
}
    `;